/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */

// Import custom modules
//window.$ = window.jQuery = require('jquery');
import 'bootstrap';
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import DepartmentGoogleMap from './modules/DepartmentGoogleMap';
import EstateGoogleMap from './modules/EstateGoogleMap';
import App from './modules/app.js';
import Carousel from './modules/carousel.js';
import './modules/custom-brinova';
import './modules/filter-voestates';
import './modules/load-more';
import LoadMorePosts from './modules/load-more-posts.js';
import Maps from './modules/maps.js';
import './modules/search-results';

const app = new App();
const carousel = new Carousel();
const loadmoreposts = new LoadMorePosts();
const maps = new Maps();
const dep_maps = new DepartmentGoogleMap();
const est_maps = new EstateGoogleMap();

/**
 * Swiper Carousel
 */
const swiperOne = new Swiper( '.swiper-one', {
	modules: [ Pagination ],

	// Responsive Breakpoints
	breakpoints: {

		// When window width is >= 320px
		320: {
			slidesPerView: 1,
			pagination: {
				el: '.swiper-pagination'
			}
		}
	}
});

const swiperTwo = new Swiper( '.swiper-two', {
	modules: [ Navigation ],
	breakpoints: {

		// When window width is >= 320px
		320: {
			slidesPerView: 1
		},

		// When window width is >= 1200px
		1200: {
			slidesPerView: 1,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			}
		}
	}
});

/* new Swiper( '.swiper-sponsor', {
	modules: [ Autoplay ],
	loop: true,
	freeMode: true,
	slidesPerView: 3,
	spaceBetween: 64,
	centeredSlides: true,
	speed: 4500,
	autoplay: {
		delay: 0,
		disableOnInteraction: true
	}
});
 */
new Swiper( '.swiper-sponsor', {

	modules: [ Autoplay ],
	loop: true,
	freeMode: true,
	loopedSlidesLimit: false,
	centeredSlides: true,

	autoplay: {
		delay: 0,
		disableOnInteraction: false
	},
	breakpoints: {
		374: {
			slidesPerView: 5,
			spaceBetween: 0

		},
		768: {
			slidesPerView: 5,
			spaceBetween: 0
		}
	},
	speed: 4500,
	grabCursor: true,
	keyboardControl: true
});

new Swiper( '.swiper-images', {
	modules: [ Autoplay, Pagination ],
	spaceBetween: 16,
	loop: true,
	loopedSlidesLimit: false,
	speed: 4500,
	grabCursor: true,
	keyboardControl: true,
	centeredSlides: true,
	slidesPerView: 1.2,
	autoplay: {
		delay: 0,
		disableOnInteraction: false
	},
	pagination: {
		el: '.swiper-pagination',
		clickable: true
	}
});


/**
 * Youtube
 */
( function( $ ) {

	$( '.bd-youtube-modal-xl' ).on( 'hide.bs.modal', function( e ) {
		$( 'iframe' ).attr( 'src', $( 'iframe' ).attr( 'src' ) );
	});
}( jQuery ) );
